<template>
    <div class="col-md-10 mx-auto">
        <page-title :title="$t('budgetTemplate.title')"></page-title>
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button"
                        class="btn btn-primary"
                        @click="backToRegister">
                    <i class="fas fa-th-list"></i> {{ $t('backToList') }}
                </button>
            </div>
            <div class="card mt-3">

                <div class="card-header bg-primary text-white">
                    <div class="h5" v-if="id">{{ $t('budget.new') }}</div>
                    <div class="h5" v-else>{{ $t('budget.edit') }}</div>
                </div>
                <div class="card-body row">
                    <div class="col-md-6">
                        <label class="font-weight-bold required">{{ $t('budget.name') }}</label>
                        <input type="text" class="form-control"
                               v-model="budgetTemplate.name"
                               :name="'name' + _uid"
                               v-validate="'required'"
                               :data-vv-as="$t('budget.name')"/>
                        <div class="text-danger" v-if="errors.has('name' + _uid)">{{ errors.first('name' + _uid) }}
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label class="font-weight-bold required">{{ $t('budget.nameEn') }}</label>
                        <input type="text" class="form-control"
                               v-model="budgetTemplate.nameEn"
                               :name="'nameEn' + _uid"
                               v-validate="'required'"
                               :data-vv-as="$t('budget.nameEn')"/>
                        <div class="text-danger" v-if="errors.has('nameEn' + _uid)">{{ errors.first('nameEn' + _uid)
                            }}
                        </div>
                    </div>
                    <table class="table table-bordered table-responsive mt-3"
                           v-if="budgetTemplate.items && budgetTemplate.items.length > 0">
                        <thead>
                        <tr>
                            <th>{{ $t('budget.group') }}</th>
                            <th>{{ $t('budget.tariffItem') }}</th>
                            <th>{{ $t('budget.description') }}</th>
                            <th>{{ $t('budget.date') }}</th>
                            <th>{{ $t('budget.quantity') }}</th>
                            <th>{{ $t('budget.singlePrice') }}</th>
                            <th>{{ $t('budget.total') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <budget-planning-row v-for="(item,index) in budgetTemplate.items" :item="item" :index="index"
                                             @deleteItem="removeItem"></budget-planning-row>
                        </tbody>
                    </table>
                    <button class="btn btn-primary" @click="addRow">{{ $t('add') }}</button>
                    <button class="btn btn-primary" @click="onSave">{{ $t('save') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BudgetPlanningRow from '../../components/budget/BudgetPlanningRow';
    import {BudgetPlanningModel, BudgetPlanningRowModel} from '../../models/models';
    import PageTitle from '../../components/common/PageTitle';

    export default {
        components: {
            PageTitle,
            BudgetPlanningRow
        },
        data() {
            return {
                id: undefined,
                loading: false,
                budgetTemplate: new BudgetPlanningModel({registerEntityId: this.registerEntityId})
            }
        },
        methods: {
            loadData() {
                if (this.id) {
                    this.$http.get(`/api/BudgetTemplate/${this.id}`).then(result => {
                        if (result.data) {
                            this.budgetTemplate = new BudgetPlanningModel(result.data);
                        }
                    }).catch(error => {
                        // TODO:
                    });
                }
            },
            addRow() {
                this.budgetTemplate.items.push(new BudgetPlanningRowModel());
            },
            removeItem(index) {
                this.budgetTemplate.items.splice(index, 1);
            },
            onSave() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        if (this.id) {
                            this.edit();
                        } else {
                            this.create();
                        }
                    }
                });
            },
            backToRegister() {
                this.$router.push('/registers/budgetTemplate');
            },
            create() {
                this.loading = true;
                this.$http.post('/api/BudgetTemplate', this.budgetTemplate).then(result => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.success'),
                        text: this.$t('notifications.successfulSavedData'),
                        position: 'top-center',
                        color: 'success'
                    });
                    this.backToRegister();
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$t('notifications.errorDataNotSaved'),
                        position: 'top-center',
                        color: 'danger'
                    });
                });
            },
            edit() {
                this.loading = true;
                this.$http.put('/api/BudgetTemplate', this.budgetTemplate).then(result => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.success'),
                        text: this.$t('notifications.successfulSavedData'),
                        position: 'top-center',
                        color: 'success'
                    });
                    this.backToRegister();
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$t('notifications.errorDataNotSaved'),
                        position: 'top-center',
                        color: 'danger'
                    });
                });
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            this.loadData();
        }
    }
</script>
